<script lang="ts">
    import { generateId } from "@/utils/generateId";

    export let width: string | number = 16;
    export let height: string | number = 16;
    export let title: string | null = null;
    export let color = "";
    export let stroke = "";
    export let className: string | null = null;
    export { className as class };
    export let viewBox = "0 0 50 50";

    $: titleId = title ? generateId("icon-title-") : undefined;
</script>

<svg
    class={className}
    xmlns="http://www.w3.org/2000/svg"
    {width}
    {height}
    {viewBox}
    role={title ? "img" : "presentation"}
    aria-labelledby={title ? titleId : undefined}
    fill="none"
>
    {#if title}
        <title id={titleId} lang="en">{title}</title>
    {/if}
    <g {stroke} fill={color}>
        <slot />
    </g>
</svg>
